/*
  Types of Events that are being used to communicate with Parent Window of chat Widget
*/
export default {
  UPDATE_USER_ID: 'UPDATE_USER_ID',
  UPDATE_PARENT_WINDOW_STYLE: 'UPDATE_PARENT_WINDOW_STYLE',
  EXPAND_MEDIA_ON_PARENT_WINDOW: 'EXPAND_MEDIA_ON_PARENT_WINDOW',
  NETOMI_FORM_SUBMIT_EVENT: 'NETOMI_FORM_SUBMIT_EVENT',
  LEARN_PARSED_ARGUMENTS: 'LEARN_PARSED_ARGUMENTS',
  SEND_MESSAGE_IN_WIDGET: 'SEND_MESSAGE_IN_WIDGET',
  SEND_LOG_TO_DATADOG: 'SEND_LOG_TO_DATADOG',
  CHANGE_BOT_CONFIG: 'CHANGE_BOT_CONFIG',
  HIDE_SUPPORT_ICON: 'HIDE_SUPPORT_ICON',
  END_SESSION: 'END_SESSION',
  OPEN_WIDGET: 'OPEN_WIDGET',
  CLOSE_WIDGET: 'CLOSE_WIDGET',
  ACCEPT_TOKEN_IN_WIDGET: 'ACCEPT_TOKEN_IN_WIDGET',
  ACCEPT_VISITOR_INFO: 'ACCEPT_VISITOR_INFO',
  TRIGGER_PENDING_EVENTS_BEFORE_INIT: 'TRIGGER_PENDING_EVENTS_BEFORE_INIT',
  TRIGGER_PENDING_EVENTS: 'TRIGGER_PENDING_EVENTS',
  HIDE_CHAT_WIDGET: 'HIDE_CHAT_WIDGET',
  INVALID_JWT_TOKEN_FALLBACK: 'INVALID_JWT_TOKEN_FALLBACK',
  SHOW_CALLOUT_BUBBLE: 'SHOW_CALLOUT_BUBBLE',
  TOGGLE_CALLOUT_BUBBLE: 'TOGGLE_CALLOUT_BUBBLE',
  CHANGE_LOCALE: 'CHANGE_LOCALE',
  TRIGGER_PENDING_EVENTS_ON_MQTT_CONNECT: 'TRIGGER_PENDING_EVENTS_ON_MQTT_CONNECT',
  TRIGGER_PENDING_EVENTS_ON_HUMAN_HANDOFF: 'TRIGGER_PENDING_EVENTS_ON_HUMAN_HANDOFF',
  TRIGGER_PENDING_EVENTS_ON_OAUTH: 'TRIGGER_PENDING_EVENTS_ON_OAUTH',
  NO_SCROLL_ALLOWED: 'NO_SCROLL_ALLOWED',
  BACK_TO_BOT: 'BACK_TO_BOT',
  SHOW_EXTERNAL_HEADER_TEXT: 'SHOW_EXTERNAL_HEADER_TEXT',
  HIDE_HEADER_MENU_BUTTONS: 'HIDE_HEADER_MENU_BUTTONS',
  PROMPT_TEST_DETAILS: 'PROMPT_TEST_DETAILS',
  RESPONSE_RECEIVED: 'RESPONSE_RECEIVED',
  MESSAGE_ERROR: 'MESSAGE_ERROR',
  USER_QUERY_SENT: 'USER_QUERY_SENT',
  CLEAR_CONVERSATION: 'CLEAR_CONVERSATION',
  REMOVE_WIDGET: "REMOVE_WIDGET",
  REMOVE_WIDGET_FROM_PARENT_WINDOW: "REMOVE_WIDGET_FROM_PARENT_WINDOW",
  SHOW_AISTUDIO_ICON_POPOVER: "SHOW_AISTUDIO_ICON_POPOVER",
  CLOSE_CHAT_WIDGET: "CLOSE_CHAT_WIDGET",
  MINIMIZE_CHAT_WIDGET: "MINIMIZE_CHAT_WIDGET",
  USER_OPEN_WIDGET: "USER_OPEN_WIDGET",
  MAXIMIZE_CHAT_WIDGET: "MAXIMIZE_CHAT_WIDGET",
  RESTORE_CHAT_WIDGET: "RESTORE_CHAT_WIDGET",
  END_CHAT_CONFIRM: "END_CHAT_CONFIRM",
  END_CHAT_CANCEL: "END_CHAT_CANCEL",
  DOWNLOAD_TRANSCRIPT: "DOWNLOAD_TRANSCRIPT",
  END_CHAT_WITH_TRANSCRIPT: "END_CHAT_WITH_TRANSCRIPT",
  SURVEY_SKIPPED: "SURVEY_SKIPPED",
  SURVEY_SUBMITTED: "SURVEY_SUBMITTED",
  END_CHAT_PILL  : "CHAT_END_PILL",
  SESSION_EXPIRE_PILL : "SESSION_EXPIRE_PILL",
  SET_CALLOUT_BUBBLE_CONFIG: "SET_CALLOUT_BUBBLE_CONFIG",
  SHOW_VISITOR_INFO_BUTTON: "SHOW_VISITOR_INFO_BUTTON",
  RA_SHOW_VISITOR_INFO_FORM: "RA_SHOW_VISITOR_INFO_FORM",
  RA_UPDATE_VISITOR_INFO_FORM: "RA_UPDATE_VISITOR_INFO_FORM",
  TERMS_AND_CONDITION_LOADED: "TERMS_AND_CONDITION_LOADED",
  TERMS_AND_CONDITION_ACCEPTED: "TERMS_AND_CONDITION_ACCEPTED",
  TERMS_AND_CONDITION_REFUSED: "TERMS_AND_CONDITION_REFUSED",
  OPEN_SECURE_FORM_OVERLAY: "OPEN_SECURE_FORM_OVERLAY",
  CLOSE_SECURE_FORM_OVERLAY: "CLOSE_SECURE_FORM_OVERLAY"
}
